import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { useMemo } from 'react';
import { css, useTheme, jsx } from '@emotion/react';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { devWarning, utilStyles } from '@paypalcorp/pp-react-utils';

var _templateObject, _templateObject2;
function styles(tokens) {
  /* istanbul ignore next */
  if (!Object.keys(tokens).length) {
    devWarning('Missing Emotion theme. Use ThemeProvider from @emotion/react to pass a valid theme from pp-react.');
    return {};
  }

  var sysBorderRadiusLg = tokens.sysBorderRadiusLg,
      sysBorderThicknessNormal = tokens.sysBorderThicknessNormal,
      sysColorBackgroundSurface = tokens.sysColorBackgroundSurface;

  var _utilStyles = utilStyles(tokens),
      elevationStyles = _utilStyles.elevationStyles;

  var level1 = elevationStyles.level1;
  var base = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    label: physical_card_base;\n    border-radius: ", ";\n    border: ", " solid transparent;\n    background-color: ", ";\n    background-origin: border-box;\n    position: relative;\n    overflow: hidden;\n    padding-top: calc(\n      100% * ", " - (2 * ", ")\n    );\n    ", ";\n  "])), sysBorderRadiusLg, sysBorderThicknessNormal, sysColorBackgroundSurface, 216 / 343, sysBorderThicknessNormal, level1);
  var content = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    label: content;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    height: 100%;\n  "])));
  return {
    base: base,
    content: content
  };
}

var _excluded = ["className", "children"];

var PhysicalCard = function (_ref) {
  var className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var tokens = useTheme();

  var _styles = useMemo(function () {
    return styles(tokens);
  }, [tokens]);

  return jsx("div", _extends({
    css: _styles.base,
    className: className,
    "data-ppui-info": "physical-card_2.2.2"
  }, rest), jsx("div", {
    css: _styles.content,
    "data-ppui": "true"
  }, children));
};

export { PhysicalCard, styles as physicalCardStyles };
